// utilities.ts
import { queryBridge } from "../../services/logging";

const dict: Record<string, Record<string, string>> = {};
const PREFIX = "i18n-missing:";

export async function translate(lang: string, key: string) {
  if (!dict[lang]) {
    try {
      const url = `/locales/${lang}/translation.json`;
      const response = await fetch(url);
      const translationData = await response.json();

      dict[lang] = translationData;
    } catch (e) {
      return key;
    }
  }

  const result = dict[lang]?.[key];

  if (typeof window !== "undefined" && !result) {
    const storeKey = PREFIX + lang;
    try {
      const list: string[] = JSON.parse(localStorage.getItem(storeKey) || "[]");
      if (!list.includes(key)) {
        list.push(key);
        localStorage.setItem(storeKey, JSON.stringify(list));
        queryBridge.warn(`Missing i18n for "${key}" in "${lang}"`);
      }
    } catch (e) {
      // localstorage error
    }
  }

  return result || key;
}

function getMissingKeys(lang: string): string[] {
  return JSON.parse(localStorage.getItem("i18n-missing:" + lang) || "[]");
}
function clearMissingKeys(lang: string) {
  localStorage.removeItem("i18n-missing:" + lang);
}

if (typeof window !== "undefined") {
  // oxlint-disable-next-line typescript/no-explicit-any
  (window as any).__language = {
    getMissingKeys,
    clearMissingKeys,
  };
}
